export const OAUTH_API_URL = `https://api-dv.brightspeed.com/genai/oauth/token`;
const BASE_URL = 'https://api-dv.brightspeed.com/genai-studio/';
//const BASE_STORAGE_URL = 'https://genai.dv-gcp.brtspd.co/secure-storage/'
//const BASE_STORAGE_URL = 'https://genai-secure-storage-dv.genai-dv.svc.cluster.local:8080/'
const BASE_STORAGE_URL = 'https://api-dv.brightspeed.com/secure-storage/'
const BASE_RAAGAS_URL = 'https://api-dv.brightspeed.com/genai-rag-service/api/v1/'
//export const OAUTH_API_URL = `${BASE_OAUTH_URL}oauth/client_credential/accesstoken?grant_type=client_credentials`;
export const SUMMARY_API_URL = `${BASE_URL}api/v1/genai/summary`;
export const GENERATE_EMAIL_API_URL = `${BASE_URL}api/v1/generate/email`;

export const FAQ_INSIGHT_CATEGORY_SEARCH_API_URL = `${BASE_URL}api/v1/admintool/genaifaqregistry`;
export const FAQ_CATEGORY_API_URL = `${BASE_URL}api/v1/admintool/genaifaqcategory/all`;
export const FEEDBACK_ADD_API_URL = `${BASE_URL}api/v1/admintool/feedback`;
export const UPDATE_FEEDBACK_API_URL = `${BASE_URL}api/v1/admintool/genaifaqhistory/updateFeedback`;
export const STORAGE_LIST_URL = `${BASE_STORAGE_URL}gcp/get_folders_files`;
export const STORAGE_UPLOAD_URL = `${BASE_STORAGE_URL}upload`;
export const STORAGE_SUMMARIZE_URL = `${BASE_STORAGE_URL}summarize`;
export const STORAGE_DOWNLOAD_URL = `${BASE_STORAGE_URL}download`;
export const STORAGE_DELETE_URL = `${BASE_STORAGE_URL}delete`;
export const AGENT_ASSIST_EVALUATION = `${BASE_URL}api/v1/admintool/agent-assist/evaluations`;
export const AGENT_ASSIST_EVALUATION_UPDATE = `${BASE_URL}api/v1/admintool/agent-assist/evaluations/update`;
export const AGENT_ASSIST_TRANSCRIPT_LINK = "https://api-dv.brightspeed.com/genai-agent-assist-rag/gcs/read-file/"

export const RAAGAS_USER_LIST_URL = `${BASE_RAAGAS_URL}admin/getUsersList/`;
export const RAAGAS_CREATE_USER_URL = `${BASE_RAAGAS_URL}restricted/admin/create_new_user`;
export const RAAGAS_BOT_LIST_URL = `${BASE_RAAGAS_URL}bot/mybots`;
export const RAAGAS_CONFIG_URL = `${BASE_RAAGAS_URL}static/config/`
export const RAAGAS_CREATE_BOT_URL = `${BASE_RAAGAS_URL}admin/create_new_bot/`;
export const RAAGAS_FILE_LIST_URL = `${BASE_RAAGAS_URL}get_files/`
export const RAAGAS_FILE_UPLOAD_URL = `${BASE_RAAGAS_URL}admin/upload_files/`
export const RAAGAS_QUERY_URL = `${BASE_RAAGAS_URL}chat/generate`;
export const RAAGAS_DELETE_URL = `${BASE_RAAGAS_URL}admin/delete/file/`
export const RAAGAS_PIPELINE_URL = 'https://api-dv.brightspeed.com/genai-agent-assist-rag/ragaas_pipeline';
export const BRIGHT_INSIGHTS_URL = 'https://api-dv.brightspeed.com/genai-studio/api/v1/admintool/genaifaqsearchresults';
export const BRIGHT_INSIGHTS_FEEDBACK_URL = 'https://api-dv.brightspeed.com/genai-studio/api/v1/admintool/genaifaqsearchresults/updateFeedback';

